import { render } from "./AppOverview.vue?vue&type=template&id=a6a4fe20&scoped=true&ts=true"
import script from "./AppOverview.vue?vue&type=script&lang=ts"
export * from "./AppOverview.vue?vue&type=script&lang=ts"

import "./AppOverview.vue?vue&type=style&index=0&id=a6a4fe20&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6a4fe20"]])

export default __exports__